<template>
  <div class="container-home">
    <div class="content-home">
      <div class="title-menu">
        <p class="text-title-menu">メニューを選んでください</p>
      </div>
      <div class="list-menu">
        <div v-for="data in menuList" :key="data.id" class="item-menu" @click="selectCollectionHome(data)">
          <!-- Template -->
          <div class="content-item-menu type-template" v-if="data.path === pathTemplate">
            <div class="item-menu-label" :class="data.menu_type === 2 ? 'bg-active-btn' : ''">汎用</div>
            <div class="item-menu-description">
              <div class="item-menu-description-content">
                <div v-for="(content, index) in data.contents" :key="index"
                     :class="index === 0 ?  'item-menu-description-button mb-1' : index === 1 ? 'mb-1' : 'item-menu-description-button'">
                  {{ content }}
                </div>
                <!--                <div class="mb-1">かきくけこ</div>-->
                <!--                <div class="item-menu-description-button">さしすせそ</div>-->
              </div>
            </div>
            <p class="title-item">{{ data.title }}</p>
          </div>

          <!-- Export XLSX -->
          <div class="content-item-menu type-export_xlsx" v-else-if="data.path === pathExport">
            <div class="item-menu-label" :class="data.menu_type === 2 ? 'bg-active-btn' : ''">汎用</div>
            <div class="item-menu-description">
              <div class="item-menu-description-content">
                <div v-for="(content, index) in data.contents" :key="index" :class="index === 1 ? 'text-right' : ''">
                  {{ content }}
                </div>
                <!--                <div class="text-right">い</div>-->
                <!--                <div>う</div>-->
              </div>
            </div>
            <p class="title-item">{{ data.title }}</p>
          </div>

          <!-- Business Card -->
          <div class="content-item-menu type-business_card" v-else-if="data.path === pathBusinessCard">
            <div class="item-menu-label" :class="data.menu_type === 2 ? 'bg-active-btn' : ''">汎用</div>
            <div class="item-menu-description">
              <div class="item-menu-description-content">
                <div v-for="content in data.contents" :key="content">{{ content }}</div>
                <!--                <div>◯◯◯◯◯</div>-->
              </div>
            </div>
            <p class="title-item">{{ data.title }}</p>
          </div>

          <!-- Other case -->
          <div class="content-item-menu" v-else>
            <p class="title-item">{{ data.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import { PATH_EXPORT_XLSX, PATH_TEMPLATE, PATH_BUSINESS_CARD } from "@/const/batch";

export default {
  data() {
    return {
      dataActive: {},
      pathBusinessCard: PATH_BUSINESS_CARD,
      pathTemplate: PATH_TEMPLATE,
      pathExport: PATH_EXPORT_XLSX,
    };
  },
  computed: {
    ...mapState({
      menuList: state => state.auth.authUser ? state.auth.authUser.menu_list : []
    }),
  },
  methods: {
    ...mapActions('template', ['getBatchList']),
    selectCollectionHome: function (data) {
      if (data.path !== PATH_TEMPLATE) {
        this.dataActive = data;
        this.dataActive.collection_id = data.path === PATH_EXPORT_XLSX ? '5' : '2'
        this.dataActive.template_id = data.path === PATH_EXPORT_XLSX ? '7' : '6'
        this.dataActive.type = data.path === PATH_EXPORT_XLSX ? 'export_xlsx' : 'business_card'
        this.dataActive.no = data.id
        this.dataActive.name = data.title
        this.$store.dispatch("home/getDataActive", this.dataActive);
      }
      this.$router.push({
        path: data.path,
      })
      // if (data.path === '/templates') {
      //   this.$router.push({
      //     name: 'templates',
      //   })
      // } else if (data.type === 'export_xlsx') {
      //   this.$router.push({
      //     name: 'export_xlsx',
      //   })
      //
      // } else {
      //   this.$router.push({
      //     name: 'business_card',
      //   })
      //   this.dataActive = data;
      //   this.$store.dispatch("home/getDataActive" , this.dataActive);
      // }
    }
  }
}
</script>

<style scoped>
.container-home {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 60px 0 0 0;
}
@media screen and (max-width: 768px) {
  .content-home  {
    min-width: 180px;
  }
  .list-menu {
    justify-content: center !important;
  }
  .item-menu {
    margin-bottom: 20px;
  }
}

.content-home {
  width: 80%;
  height: 100%;
  margin: auto;
}

.title-menu {
  border-left: 4px solid #FDB92C;
  margin-bottom: 20px;
}

.text-title-menu {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #0F172A;
  margin-left: 15px;
  display: inline-block;
}

.list-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.item-menu {
  width: 180px;
  height: 180px;
  margin-right: 15px;
  position: relative;
  cursor: pointer;
  background: #FAFAFA;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
}

.content-item-menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.type-business_card .item-menu-label {
  color: #000000;
}

.content-item-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-menu-description {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.item-menu-description-button {
  border: 1px solid #565C70;
  border-radius: 2em;
  text-align: center;
  padding: 2px 10px;
}

.item-menu-label {
  background: #343744;
  color: #FFFFFF;
  padding: 2px 10px;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  font-size: 14px;
}

.type-template .item-menu-description .item-menu-description-content {
  text-align: center;
  font-size: 12px;
}

.type-export_xlsx .item-menu-description .item-menu-description-content {
  border: 2px solid #565C70;
  width: 60px;
  padding: 10px;
  font-size: 12px;
}

.type-business_card .item-menu-description .item-menu-description-content {
  border: 2px solid #565C70;
  padding: 10px 20px;
  font-size: 12px;
}

.number-item {
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #000;
  margin-bottom: 10px;
}

.title-item {
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: #000;
  text-align: center;
  padding: 10px;
}

</style>
